const develop = 'development' === process.env.NODE_ENV;

let host = window.location.href;
host = host.substring(0, host.indexOf("/", 8));

const demoServer = host + '/demo/v2/api-docs';

const ruleServer = host + '/ruleengine/v2/api-docs';

const server = host + '/configuration/v2/api-docs';

const wxSysCode = "kfConfiguration"

const contextPath = "/configuration/"

const dx3dHost = "https://open.daxiangyun.com"

const dx3dApiId = "1efe6c4d188c421c9107ad111eb9d9e3"

const dx3dApiKey = "2d88a2910b804ea7bd056613b9ebb54d"

export default {
  dx3dHost,
  dx3dApiId,
  dx3dApiKey,
  develop,
  demoServer,
  ruleServer,
  server,
  wxSysCode,
  contextPath
}
